// extracted by mini-css-extract-plugin
var _1 = "TopbarCreatePostButton-module__animateUploadProgressBarWidth--ZHaKN";
var _2 = "TopbarCreatePostButton-module__animatedBackground--j6dTV";
var _3 = "TopbarCreatePostButton-module__container--rsKgJ";
var _4 = "TopbarCreatePostButton-module__dropdownButton--jEq6m";
var _5 = "TopbarCreatePostButton-module__input--X_iin";
var _6 = "TopbarCreatePostButton-module__mainButton--APzQE";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "dropdownButton", _5 as "input", _6 as "mainButton" }
